import Header from "@/components/layout/Header";
import { SongOrderForm } from "@/components/song-form";
import SEO from "@/components/SEO";

const CreateSong = () => {
  return (
    <div className="min-h-screen bg-background music-note-pattern">
      <SEO
        title="Create Your Custom Song"
        description="Tell us your story and we'll compose a personalized song just for you. Share your memories, choose a style, and receive your custom music gift."
        canonical="https://yourmomentsong.com/create"
        noindex
      />
      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <SongOrderForm />
        </div>
      </main>
    </div>
  );
};

export default CreateSong;
